const BUKA20_PREFIX_URL = process.env.API_VPNONTRADER_HOST

const VOUCHER_SCOPE = 'product.*.*'

export default {
  getVoucherku(params) {
    return this.get(`${BUKA20_PREFIX_URL}/v1/vouchers/voucherkus`, VOUCHER_SCOPE, {
      responseErrorJson: true,
      enableAuthHeader: true,
      params,
    })
  },
  bulkValidateVoucher(data) {
    return this.post(`${BUKA20_PREFIX_URL}/v1/vouchers/bulk-validate`, VOUCHER_SCOPE, {
      data,
      responseErrorJson: true,
      enableAuthHeader: true,
    })
  },
}
